import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { EMPTY_STRING, REGEX } from "../../constants";
import { checkBlackIcon } from "../../assets/icons";

const { NUMERIC } = REGEX;
const MAX_LENGTH = 15;
const ON_CLICK_EVENTS = {
  KEY_BACKSPACE: "Backspace",
  KEY_DELETE: "Delete",
  KEY_ENTER: "Enter",
  KEY_TAB: "Tab",
  ArrowLeft: "ArrowLeft",
  ArrowRight: "ArrowRight",
};

const checkIsNumericKeyPressed = (char) => NUMERIC.test(char);

const CustomNumericEditor = forwardRef((props, ref) => {
  const { charPress, value } = props;
  const refInput = useRef();
  const [numericValue, setNumericValue] = useState(EMPTY_STRING);

  useEffect(() => {
    const currentValue = checkIsNumericKeyPressed(charPress)
      ? charPress
      : value;
    currentValue && setNumericValue(currentValue);
  }, [charPress, value]);

  // focus on the input
  useEffect(() => {
    // get ref from React component
    refInput.current.focus();
  }, []);

  const isLeftOrRightKeyPressed = (event) =>
    [ON_CLICK_EVENTS.ArrowLeft, ON_CLICK_EVENTS.ArrowRight].includes(event.key);

  const isDeleteOrBackspaceKeyPressed = (event) =>
    [ON_CLICK_EVENTS.KEY_DELETE, ON_CLICK_EVENTS.KEY_BACKSPACE].includes(
      event.key
    );

  const finishedEditingPressed = (event) => {
    const key = event.key;
    return key === ON_CLICK_EVENTS.KEY_ENTER || key === ON_CLICK_EVENTS.KEY_TAB;
  };

  const onKeyDown = (event) => {
    if (
      isLeftOrRightKeyPressed(event) ||
      isDeleteOrBackspaceKeyPressed(event)
    ) {
      event.stopPropagation();
      return;
    }

    if (!finishedEditingPressed(event) && !checkIsNumericKeyPressed(event.key))
      event.preventDefault();
  };

  /* Component Editor Lifecycle methods */
  useImperativeHandle(ref, () => {
    return {
      // the final value to send to the grid, on completion of editing
      getValue() {
        return numericValue;
      },
    };
  });

  return (
    <div className="flex items-center w-full h-full bg-white p-2 pl-4 gap-2">
      <input
        ref={refInput}
        className="w-full h-full text-black border-none outline-none"
        value={numericValue}
        onChange={(event) => setNumericValue(event.target.value)}
        onKeyDown={(event) => onKeyDown(event)}
        maxLength={MAX_LENGTH}
      />
      <img
        src={checkBlackIcon}
        alt="check-icon"
        className="w-4 h-4 cursor-pointer"
        onClick={() => props.api.stopEditing()}
      />
    </div>
  );
});

CustomNumericEditor.displayName = "CustomNumericEditor";

export default CustomNumericEditor;
